module.exports = __webpack_public_path__ + "static/mobile-hero-complete-package-0b922f0100d181dfcbc669bedc32863a.jpg";